module.exports = __webpack_public_path__ + "static/media/hands_04.68d61d9f.svg";